import GAClientSettings from '@redbubble/ga-client-settings';
import { format, parse, isValid } from 'date-fns';
import get from 'lodash/get';
import { clientError } from '../errorReporting';
import { rbExperimentCookieData, RB_EXPERIMENT_COOKIE } from '../rbRailsCookie';

export const formatString = s => s || '';

export const formatDate = date => {
  if (!date) return '';

  const parsedDate = parse(date);

  if (date && isValid(parsedDate)) {
    return format(parsedDate, 'YYYYMMDD');
  }

  return '';
};

export const createGADimensions = params => {
  const { userInfo, userAccount, cookies, federatedId } = params;

  const experiments = [];
  const experimentData = rbExperimentCookieData(cookies[RB_EXPERIMENT_COOKIE]);
  if (Object.keys(experimentData).length > 0) {
    experiments.push(experimentData);
  }

  const joinedDate = formatDate(get(userAccount, 'joinedAt'));
  const onboardedDate = formatDate(get(userAccount, 'onboardedAt'));
  const artistUploadsGroup = formatString(
    get(userAccount, 'analytics.artistUploadsGroup')
  );
  const artistSalesGroup = formatString(
    get(userAccount, 'analytics.artistSalesGroup')
  );
  const federatedID = formatString(federatedId);
  const enrolments = get(userInfo, 'enrolments');

  const dimensions = {
    joinedDate,
    onboardedDate,
    artistUploadsGroup,
    artistSalesGroup,
    federatedID
  };

  const gaClientSettings = new GAClientSettings({
    userInfo,
    experiments,
    enrolments,
    userAccount,
    cookies,
    dimensions
  });

  try {
    gaClientSettings.validateDimensions();
    return gaClientSettings.buildDimensions();
  } catch (e) {
    clientError(e);
    return null;
  }
};

export const setGADimensions = params => {
  const {
    userInfo,
    userAccount,
    cookies,
    analyticsData,
    setGAClientOptions
  } = params;

  const dimensions = createGADimensions({
    userInfo,
    userAccount,
    cookies,
    federatedId: analyticsData.federatedId
  });

  if (dimensions) {
    setGAClientOptions(dimensions);
  }
};
